import { render, staticRenderFns } from "./HelpPdfDesigner.vue?vue&type=template&id=481f5736&scoped=true&"
import script from "./HelpPdfDesigner.vue?vue&type=script&lang=ts&"
export * from "./HelpPdfDesigner.vue?vue&type=script&lang=ts&"
import style0 from "./HelpPdfDesigner.vue?vue&type=style&index=0&id=481f5736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f5736",
  null
  
)

export default component.exports